module.exports = __webpack_public_path__ + "static/favicon-16465ccd2cc505b1f7d394aae945f022.ico";